import React from 'react';

const Settings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="mt-1 text-sm text-gray-500">
          Configure system settings and preferences
        </p>
      </div>
      
      <div className="card">
        <p className="text-gray-500">Settings interface coming soon...</p>
      </div>
    </div>
  );
};

export default Settings;